import React from 'react';
import LogoJMM from '../LogoJMM';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ErrorComponent = function ErrorComponent(_ref) {
  var error = _ref.error,
    componentStack = _ref.componentStack,
    resetError = _ref.resetError;
  var hardReload = function hardReload(e) {
    e.preventDefault();
    localStorage.clear();
    window.location.reload(true);
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      margin: '0 auto',
      textAlign: 'center',
      width: '100%',
      maxWidth: '600px',
      fontFamily: 'ZonaPro Black, sans-serif'
    },
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        textAlign: 'center'
      },
      children: /*#__PURE__*/_jsx(LogoJMM, {
        size: "middle"
      })
    }), /*#__PURE__*/_jsx("h3", {
      style: {
        fontFamily: 'ZonaPro Black, sans-serif'
      },
      children: "Es ist leider ein Fehler aufgetreten. Unser Team wurde bereits dar\xFCber informiert."
    }), /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx("a", {
        style: {
          color: 'blue',
          cursor: 'pointer',
          textDecoration: 'underline'
        },
        href: "/de/",
        onClick: hardReload,
        children: "Klicken Sie hier"
      }), ' ', "um sich abzumelden und das System zur\xFCck zu setzen. Bitte melden Sie sich danach wieder an und versuchen es erneut."]
    }), /*#__PURE__*/_jsxs("p", {
      children: ["Sollte der Fehler weiterhin auftreten, kontaktieren Sie uns bitte unter", ' ', /*#__PURE__*/_jsx("a", {
        href: "tel:+49 40 87408088",
        children: "+49 40 87408088"
      }), " oder", ' ', /*#__PURE__*/_jsx("a", {
        href: "mailto:hallo@jobmatch.me",
        children: "hallo@jobmatch.me"
      }), ".", /*#__PURE__*/_jsx("br", {}), "Wir unterst\xFCtzen Sie gerne jederzeit pers\xF6nlich."]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        marginTop: '50px',
        backgroundColor: 'grey',
        borderRadius: '8px',
        padding: '25px',
        color: 'white',
        textAlign: 'left'
      },
      children: [/*#__PURE__*/_jsx("span", {
        children: "Bei R\xFCckfragen helfen uns ggf. folgende Informationen \xFCber den Aufgetretenen Fehler:"
      }), /*#__PURE__*/_jsx("pre", {
        children: /*#__PURE__*/_jsxs("code", {
          children: [error.toString(), componentStack]
        })
      })]
    })]
  });
};
export default ErrorComponent;